<div class="loading-bar">
  <div class="progress" *ngIf="started">
    <div class="progress-bar indeterminate" role="progressbar" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"
         style="width: 65%"></div>
  </div>
</div>
